import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Edit, Delete as DeleteIcon } from '@mui/icons-material';
import Progress from '../Progress';
import Notification from '../Notification';
import { useNavigate } from 'react-router-dom';

function EmployeeRolesTable({ onEdit, reloadKey }) {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '' });
  const navigate = useNavigate();

  const handleLocalDelete = (role) => {
    const confirmDelete = window.confirm(`Do you want to delete role "${role.role_name}"? This will only update the current view (no API call).`);
    if (!confirmDelete) return;

    setRoles((prev) => prev.filter((r) => r.role_id !== role.role_id));
    setNotify({
      isOpen: true,
      message: 'Role deleted locally (no API configured yet).',
      type: 'success',
    });
  };

  const fetchRoles = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/company-master/get-employee-roles`
      );
      const data = response.data?.data || [];
      setRoles(data);
    } catch (e) {
      if (e.response && e.response.status === 401) {
        setNotify({
          isOpen: true,
          message: 'Session Expired!',
          type: 'error',
        });
        setTimeout(() => {
          navigate('/');
        }, 1000);
      } else {
        setNotify({
          isOpen: true,
          message: 'Failed to fetch employee roles',
          type: 'error',
        });
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchRoles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloadKey]);

  if (loading) {
    return <Progress />;
  }

  return (
    <>
      <div className="table-parent">
        <table className="table big-table">
          <thead className="table-dark">
            <tr>
              <th scope="col" className="table-dark">Actions</th>
              <th scope="col">Role Name</th>
              <th scope="col">Role Description</th>
              <th scope="col">Status</th>
            </tr>
          </thead>
          <tbody>
            {roles.map((role) => (
              <tr key={role.role_id}>
                <td>
                  <div style={{ display: 'flex', gap: '4px' }}>
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => onEdit && onEdit(role)}
                    >
                      <Edit /> Modify
                    </button>
                    <button
                      type="button"
                      disabled
                      className="btn btn-outline-danger btn-sm"
                      onClick={() => handleLocalDelete(role)}
                    >
                      <DeleteIcon fontSize="small" />
                      Delete
                    </button>
                  </div>
                </td>
                <td>{role.role_name}</td>
                <td>{role.role_description}</td>
                <td>{role.status === 1 ? 'Active' : 'Inactive'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Notification notify={notify} setNotify={setNotify} />
    </>
  );
}

export default EmployeeRolesTable;

